import { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/sections/Hero';
import Ticker from '../components/sections/Ticker';
import TrustBar from '../components/sections/TrustBar';
import Property from '../components/sections/Property';
import Business from '../components/sections/Business';
import Personal from '../components/sections/Personal';
import Coverage from '../components/sections/Coverage';
import Testimonials from '../components/sections/Testimonials';
import Careers from '../components/sections/Careers';
import Footer from '../components/Footer';
import CookieBanner from '../components/CookieBanner';

export default function Home() {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="relative overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <TrustBar />
        <Property />
        <Business />
        <Personal />
        <Coverage />
        <Testimonials />
        <Careers />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
